import { defineCapability } from 'nest/capabilities';
import { args } from 'nest/common/args';

export const GLOBAL_KEYBOARD_SHORTCUT_HANDLER_CAP = defineCapability({
  name: 'GLOBAL_KEYBOARD_SHORTCUT_HANDLER_CAP' as const,
  args: {
    keyboardEventKeys: args.keyboardEventKeys(),
  },
});
